import React from 'react';
import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';

function ConfirmModal(props) {
  const {
    isOpen,
    onClick,
    Icon,
    title,
    desc,
    titleBtn,
    onClose,
    isLoading,
    titleBtnCancel,
    variant,
    type
  } = props;
  return (
    <>
      <Modal isOpen={isOpen} isCentered onClose={onClose}>
        <ModalOverlay />
        <ModalContent borderRadius={'12px'} w={'407px'} p={'16px'} bgColor={'light.200'}>
          <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
            <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
              <p className="text-xl font-[800]">{title}</p>
              <Image
                className="w-[40px] h-[40px] cursor-pointer"
                src={CloseModalIcon}
                onClick={onClose}
                alt=""
              />
            </div>
          </ModalHeader>
          <ModalBody p={0} mb={'35px'}>
            {Icon ? (
              <Box p={'1.5625rem'}>
                <img src={Icon} alt="" className="mx-auto"></img>
              </Box>
            ) : (
              <></>
            )}
            <Flex flexDirection={'column'} gap={'10px'}>
              {type && (
                <Text
                  fontSize={'32px'}
                  color={'dark-green'}
                  fontWeight={'900'}
                  textAlign={'center'}
                >
                  Error
                </Text>
              )}
              <Text fontSize={'1.125rem'} px={5} textAlign={'center'}>
                {desc}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter p="0" gap={'10px'}>
            <Button
              type="submit"
              w="100%"
              variant={'growth-green-solid'}
              onClick={onClose}
              height={'42px'}
              fontSize={'16px'}
              _focusVisible={{
                boxShadow: 'none'
              }}
            >
              {titleBtnCancel ?? 'Cancel'}
            </Button>
            <Button
              w="100%"
              variant={variant ?? 'red'}
              onClick={onClick}
              height={'42px'}
              fontSize={'16px'}
              isLoading={isLoading}
              _focusVisible={{
                boxShadow: 'none'
              }}
            >
              {titleBtn}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ConfirmModal;
